// Which view the search results arrive in — cards or the table.
//
// Config, not a constant, for the same reason "Opens as" is (see
// actionButtons.js): the right answer differs per form. A candidate search is
// read as a shortlist, where a card carries the photo, the headline and the
// actions; a submissions or finance search is read as rows to compare. Both are
// the same component, so the screen cannot decide for either of them.
//
// Cards are the default because that is the majority case for the search screens
// this exists for, and because a form saved before this key existed is a
// candidate search.

export const RESULTS_VIEW_OPTIONS = [
  { value: 'card', label: 'Cards' },
  { value: 'list', label: 'List' },
];

export const DEFAULT_RESULTS_VIEW = 'card';

const RESULTS_VIEW_VALUES = RESULTS_VIEW_OPTIONS.map((option) => option.value);

// Anything unrecognised lands on the default rather than passing through: an
// unknown value reaches ListView as an activeView it cannot render, which is a
// blank results area with no clue why.
export function resolveResultsView(schema) {
  const configured = String(schema?.resultsDefaultView ?? '').trim();
  return RESULTS_VIEW_VALUES.includes(configured) ? configured : DEFAULT_RESULTS_VIEW;
}

// What the results search box says it searches.
//
// Free text rather than a derived list of column labels: the same component
// renders the search screen for any module, and the box searches server-side
// fields that are not always columns (a candidate search matches Skill, which
// is not one). Only the admin knows the right sentence.
//
// Returns undefined, never an empty string, for a form that configures nothing:
// an empty string satisfies ListView's default parameter and leaves the box
// blank, which reads as a bug rather than as a default.
export function resolveResultsSearchPlaceholder(schema) {
  const configured = String(schema?.resultsSearchPlaceholder ?? '').trim();
  return configured || undefined;
}
